import { ChangeDetectionStrategy, Component, ContentChild, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { UiControlValueAccessorDirective } from '../../basics/ui-control-value-accessor';
import { BoschUiValidationErrorComponent } from '../bosch-ui-validation-error/bosch-ui-validation-error.component';
import { getRandomId } from '../../utils/get-random-id';
import { provideCustomCVA } from '../../basics/ui-custom-cva.provider';
import { TranslateModule } from '@ngx-translate/core';
import { BoschUiInputAutofocusDirective } from '../../directives/bosch-ui-input-autofocus-directive/bosch-ui-input-autofocus.directive';
import { BoschUiDisableControlDirective } from '../../directives/bosch-ui-disable-control/bosch-ui-disable-control.directive';
import { AutofocusDirective } from '../../basics/models/bosch-ui-autofocus-directive.interface';
import { InputWithAutofocus } from '../../basics/models/bosch-ui-input-with-autofocus.interface';

@Component({
  selector: 'bosch-ui-input',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BoschUiValidationErrorComponent,
    TranslateModule,
    BoschUiInputAutofocusDirective,
    BoschUiDisableControlDirective,
  ],
  templateUrl: './bosch-ui-input-text.component.html',
  styleUrls: ['./bosch-ui-input-text.component.scss'],
  providers: [provideCustomCVA(BoschUiInputTextComponent)],
  exportAs: 'input-text',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiInputTextComponent
  extends UiControlValueAccessorDirective<string | number | null>
  implements OnInit, InputWithAutofocus
{
  @Input() label: string | null = null;
  @Input() placeholder = '';
  @Input() readonly = false;
  @Input() autofocus = false;
  @ViewChild(BoschUiInputAutofocusDirective) autofocusDirective!: AutofocusDirective;
  @ContentChild(BoschUiValidationErrorComponent, { static: false }) errorRef: BoschUiValidationErrorComponent | null =
    null;
  readonly id: string = getRandomId('input-text');

  override ngOnInit(): void {
    super.ngOnInit();

    this.control.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: string | number | null) => {
      this.onChange(value);
    });
  }

  focus(): void {
    this.autofocusDirective.focus();
  }
}
